import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect } from 'react';
import Button from 'components/Form/Button';
import messages from '../../../../messages';
import WarningBox from './WarningBox';
const Actions = ({ onSetComponent, onCancel })=>{
    const onAccept = ()=>onSetComponent('DownloadSummary');
    return /*#__PURE__*/ _jsxs("div", {
        className: "modal__actions row",
        children: [
            /*#__PURE__*/ _jsx("div", {
                className: "col-6",
                children: /*#__PURE__*/ _jsx(Button, {
                    styleModifier: "primary",
                    labelMessage: messages.buttons.warningReject,
                    className: "btn--block",
                    onClick: onCancel
                })
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "col-6",
                children: /*#__PURE__*/ _jsx(Button, {
                    styleModifier: "primary",
                    labelMessage: messages.buttons.warningAccept,
                    className: "btn--block btn--filled",
                    onClick: onAccept
                })
            })
        ]
    });
};
const WarningsBeforeDownloadData = ({ warnings, onSetComponent, onSetHeaderMessage, onCancel })=>{
    const warningsLen = warnings.length;
    useEffect(()=>{
        if (warnings.length === 1) {
            const warning = warnings[0];
            const warningMessage = messages.headers[`warning${warning}Single`] || messages.headers[`warning${warning}`];
            if (warningMessage) {
                onSetHeaderMessage(warningMessage);
            }
        } else {
            onSetHeaderMessage(messages.headers.warningsBeforeDownloadData);
        }
        return ()=>onSetHeaderMessage();
    }, []);
    return /*#__PURE__*/ _jsxs("div", {
        children: [
            warnings.map((warningType, idx)=>/*#__PURE__*/ _jsx(WarningBox, {
                    warningType: warningType,
                    warningsLen: warningsLen,
                    idx: idx
                }, warningType)),
            /*#__PURE__*/ _jsx(Actions, {
                onSetComponent: onSetComponent,
                onCancel: onCancel
            })
        ]
    });
};
export default WarningsBeforeDownloadData;
